import {channel} from 'redux-saga'
import {cancelled, put, select, take} from 'redux-saga/effects';
import {watch, runWhile} from 'store/effects';
import {config} from 'helpers';
import {user, userIsOnline} from 'store/session';

export function* socketManager() {
  yield watch(userIsOnline, function* (on) {
    yield runWhile(socket, on);
  });
}

function* socket() {
  const userId = (yield select(user)).id;
  const ws = new WebSocket(`wss://${config.domain}:9987`);
  const wsChannel = channel();
  try {
    ws.onopen = () => ws.send(JSON.stringify({
      action: 'init',
      userId,
      deviceId: config.deviceId,
    }));

    ws.onerror = () => {
      wsChannel.put({
        type: 'SERVER_SOCKET_ERROR',
        error: 'Websocket error',
        extra: event,
      });
    }

    ws.onmessage = ({ data }) => {
      try {
        const { action } = JSON.parse(data);
        if (!messages[action]) {
          throw new Error('Unrecognized message');
        }
        wsChannel.put({
          type: messages[action]
        });
      } catch (error) {
        wsChannel.put({
          type: 'SERVER_SOCKET_ERROR',
          error: 'Websocket error. ' + error.message,
          extra: 'Original: ' + data,
        });
      }
    }

    while (true) {
      const action = yield take(wsChannel);
      yield put(action);
    }
  } finally {
    if (yield cancelled() && ws.readyState) {
      ws.close();
    }
  }
}

const messages = {
  'sync': 'SERVER_READ',
  'google-sync': 'GOOGLE_CALENDAR_READ',
  'export-sync': 'EXPORTED_FILES_READ',
  'logout': 'SESSION_LOGOUT',
}
